// Extracted from src/routes/index.tsx — shared across landing/Trendi pages.
export function ChannelLogo({ name, className = "w-6 h-6" }: { name: string; className?: string }) {
  switch (name) {
    case "Instagram":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <defs>
            <linearGradient id="ig" x1="0" y1="1" x2="1" y2="0">
              <stop offset="0" stopColor="#FED576" />
              <stop offset="0.26" stopColor="#F47133" />
              <stop offset="0.61" stopColor="#BC3081" />
              <stop offset="1" stopColor="#4C63D2" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" fill="url(#ig)" />
          <circle cx="12" cy="12" r="4" fill="none" stroke="#fff" strokeWidth="1.8" />
          <circle cx="17.5" cy="6.5" r="1.2" fill="#fff" />
        </svg>
      );
    case "Telegram":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <circle cx="12" cy="12" r="11" fill="#229ED9" />
          <path
            d="M5.5 11.8l11.6-4.5c.6-.2 1.1.2.9.9l-2 9.4c-.2.7-.6.9-1.2.6l-3.3-2.4-1.6 1.6c-.2.2-.4.3-.7.3l.3-3.4 6.2-5.6c.3-.2-.1-.4-.4-.2l-7.6 4.8-3.3-1c-.7-.2-.7-.7.1-1z"
            fill="#fff"
          />
        </svg>
      );
    case "WhatsApp":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <circle cx="12" cy="12" r="11" fill="#25D366" />
          <path
            d="M16.7 13.9c-.3-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1-.7-.3-1.4-.7-2-1.3-.5-.5-.9-1.1-1.3-1.7-.1-.2 0-.4.1-.5l.4-.5c.1-.1.1-.2.2-.4 0-.1 0-.3-.1-.4-.1-.1-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.4-.2.3-.9.9-.9 2.2 0 1.3.9 2.5 1 2.7.1.2 1.8 2.7 4.3 3.8.6.3 1.1.4 1.5.5.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2-.1-.1-.2-.2-.4-.3z"
            fill="#fff"
          />
        </svg>
      );
    case "Bale":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <circle cx="12" cy="12" r="11" fill="#009688" />
          <path
            d="M7 8.5c0-.6.5-1 1-1h3c2 0 3.3 1 3.3 2.6 0 1-.6 1.7-1.4 2v.1c1.3.2 2.1 1.1 2.1 2.4 0 1.9-1.5 3-4 3H8c-.5 0-1-.5-1-1V8.5zm2 1v2.2h2c.9 0 1.5-.4 1.5-1.1s-.6-1.1-1.5-1.1H9zm0 4v2.5h2.2c1 0 1.7-.5 1.7-1.3 0-.8-.7-1.2-1.7-1.2H9z"
            fill="#fff"
          />
        </svg>
      );
    case "Rubika":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <defs>
            <linearGradient id="rb" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#FF5722" />
              <stop offset="1" stopColor="#E91E63" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="6" fill="url(#rb)" />
          <path
            d="M8 7h4.5c2 0 3.3 1.1 3.3 2.9 0 1.3-.7 2.3-1.9 2.7l2 4.4h-2.3l-1.7-4H10v4H8V7zm2 1.8v2.5h2.2c.9 0 1.5-.5 1.5-1.3s-.6-1.2-1.5-1.2H10z"
            fill="#fff"
          />
        </svg>
      );
    case "Eitaa":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <circle cx="12" cy="12" r="11" fill="#FF9800" />
          <path d="M7 8h10v2h-4v8h-2v-8H7V8z" fill="#fff" />
        </svg>
      );
    case "Website":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <circle cx="12" cy="12" r="11" fill="#0EA5E9" />
          <path
            d="M1.6 12h20.8M12 1.2c2.8 3 4.2 6.6 4.2 10.8S14.8 19.8 12 22.8c-2.8-3-4.2-6.6-4.2-10.8S9.2 4.2 12 1.2z"
            fill="none"
            stroke="#fff"
            strokeWidth="1.5"
          />
        </svg>
      );
    case "Email":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <rect x="2" y="4.5" width="20" height="15" rx="4" fill="#EA4335" />
          <path
            d="M4.5 8.5l7.5 5 7.5-5"
            fill="none"
            stroke="#fff"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "SMS":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <path d="M4 3h16a2 2 0 012 2v10a2 2 0 01-2 2H9l-5 4V5a2 2 0 012-2z" fill="#7C3AED" />
          <circle cx="8.5" cy="10" r="1.2" fill="#fff" />
          <circle cx="12" cy="10" r="1.2" fill="#fff" />
          <circle cx="15.5" cy="10" r="1.2" fill="#fff" />
        </svg>
      );
    case "API":
      return (
        <svg viewBox="0 0 24 24" className={className}>
          <rect x="2" y="2" width="20" height="20" rx="6" fill="#111827" />
          <path
            d="M9.6 8.4L6 12l3.6 3.6M14.4 8.4L18 12l-3.6 3.6"
            fill="none"
            stroke="#22D3EE"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
}
export default ChannelLogo;
